// extracted by mini-css-extract-plugin
export var emailBlockLink = "_jt-0";